// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { GitIntegrationPlatformSchema } from '../inputTypeSchemas/GitIntegrationPlatformSchema'
import { GitHubAppKindSchema } from '../inputTypeSchemas/GitHubAppKindSchema'
import { PrSyncModeSchema } from '../inputTypeSchemas/PrSyncModeSchema'

/////////////////////////////////////////
// GIT INTEGRATION SCHEMA
/////////////////////////////////////////

export const GitIntegrationSchema = z.object({
  platform: GitIntegrationPlatformSchema,
  gitHubAppKind: GitHubAppKindSchema.nullable(),
  prSyncMode: PrSyncModeSchema,
  id: z.string(),
  tenantId: z.string().nullable(),
  name: z.string().nullable(),
  isDisabled: z.boolean(),
  baseUrl: z.string().nullable(),
  apiVersion: z.string().nullable(),
  webhookSecretEnc: z.string().nullable(),
  twingateNetworkId: z.string().nullable(),
  tailscaleNetworkId: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
})

export type GitIntegration = z.infer<typeof GitIntegrationSchema>

export default GitIntegrationSchema;
